import { Extension, type Editor, type Range } from '@tiptap/core';
import { Color } from '@tiptap/extension-color';
import Link from '@tiptap/extension-link';
import ListItem from '@tiptap/extension-list-item';
import Placeholder from '@tiptap/extension-placeholder';
import TextAlign from '@tiptap/extension-text-align';
import TextStyle from '@tiptap/extension-text-style';
import Youtube from '@tiptap/extension-youtube';
import StarterKit from '@tiptap/starter-kit';
import { Commands } from './Menus/SuggestionsMenu/commandsExtension';
import { suggestions } from './Menus/SuggestionsMenu/suggestions';
import {
  Image,
  ImageDialog,
  Pdf,
  PdfDialog,
  Video,
  VideoDialog,
} from './Extensions/customExtensions';
import { Table, TableCell, TableHeader, TableRow } from './Extensions/table';
import { EditedSincePublishMark } from './Extensions/editedSincePublishMark';
import type { TiptapFileSrcResolver } from './useTiptapFileSrc';

const BlockMetadata = Extension.create({
  name: 'blockMetadata',

  addGlobalAttributes() {
    return [
      {
        types: [
          'paragraph',
          'heading',
          'bulletList',
          'orderedList',
          'blockquote',
          'table',
          'image',
          'video',
          'pdf',
          'youtube',
        ],
        attributes: {
          blockId: {},
          blockType: {},
        },
      },
    ];
  },
});

export function getExtensions(resolveFileSrc: TiptapFileSrcResolver) {
  return [
    BlockMetadata,
    Color.configure({ types: [TextStyle.name, ListItem.name] }),
    TextStyle,
    StarterKit.configure({
      bulletList: {
        keepMarks: true,
        keepAttributes: false,
      },
      orderedList: {
        keepMarks: true,
        keepAttributes: false,
      },
    }),
    Placeholder.configure({
      placeholder: "Enter text or type '/' for commands...",
    }),
    Commands.configure({
      suggestions: {
        char: '/',
        command: ({
          editor,
          range,
          props,
        }: {
          editor: Editor;
          range: Range;
          props: { command: (p: { editor: Editor; range: Range }) => void };
        }) => props.command({ editor, range }),
        ...suggestions,
      },
    }),
    TextAlign.configure({
      types: ['heading', 'paragraph', 'image'],
    }),
    Link,
    Table,
    TableRow,
    TableHeader,
    TableCell,
    Image.configure({ resolveFileSrc }),
    ImageDialog,
    Video.configure({ resolveFileSrc }),
    VideoDialog,
    Youtube.configure({
      HTMLAttributes: { referrerpolicy: 'strict-origin-when-cross-origin' },
    }),
    Pdf.configure({ resolveFileSrc }),
    PdfDialog,
    EditedSincePublishMark,
  ];
}
